export default __webpack_public_path__ + "static/media/more.a2866fd5.svg";